import { doc, getDoc, setDoc, updateDoc, serverTimestamp, deleteField } from 'firebase/firestore';
import { db } from '../firebase';

const userRef = (uid) => doc(db, 'users', uid);

// upsert progress for a playId (legacy, kept for compatibility)
// data: { playId, popupId?, season?, index?, title?, img?, path: '/play/<id>', lastTimeSec }
export async function upsert(uid, playId, data) {
  if (!uid || !playId) return;
  const ref = userRef(uid);
  const path = `continue.${String(playId)}`;
  const payload = {
    playId: String(playId),
    path: data?.path || `/play/${String(playId)}`,
    popupId: data?.popupId || null,
    season: data?.season || null,
    index: data?.index || null,
    title: data?.title || data?.epTitle || '',
    img: data?.img || '',
    lastTimeSec: Math.max(0, Math.floor(Number(data?.lastTimeSec || 0))),
    updatedAt: serverTimestamp(),
  };
  try {
    await updateDoc(ref, { [path]: payload });
  } catch (e) {
    await setDoc(ref, { continue: { [String(playId)]: payload } }, { merge: true });
  }
}

export async function list(uid, max = 10) {
  if (!uid) return [];
  const d = await getDoc(userRef(uid));
  const data = d.exists() ? (d.data() || {}) : {};
  const cont = data.continue || {};
  const arr = Object.values(cont || {});
  arr.sort((a,b) => (b.updatedAt?.seconds || 0) - (a.updatedAt?.seconds || 0));
  return arr.slice(0, max);
}

// New per-series storage: only remember the LAST watched playId per series (popupId)
// This matches the requirement not to track minutes/seconds.
export async function upsertSeries(uid, popupId, data) {
  if (!uid || !popupId) return;
  const ref = userRef(uid);
  const path = `continueSeries.${String(popupId)}`;
  const payload = {
    popupId: String(popupId),
    playId: data?.playId ? String(data.playId) : null,
    path: data?.path || (data?.playId ? `/play/${String(data.playId)}` : ''),
    epTitle: data?.epTitle || data?.title || '',
    showTitle: data?.showTitle || '',
    img: data?.img || '',
    season: data?.season || null,
    index: data?.index || null,
    updatedAt: serverTimestamp(),
  };
  try {
    await updateDoc(ref, { [path]: payload });
  } catch (e) {
    await setDoc(ref, { continueSeries: { [String(popupId)]: payload } }, { merge: true });
  }
}

export async function listSeries(uid, max = 20) {
  if (!uid) return [];
  const d = await getDoc(userRef(uid));
  const data = d.exists() ? (d.data() || {}) : {};
  const cs = data.continueSeries || {};
  const arr = Object.values(cs || {});
  arr.sort((a,b) => (b.updatedAt?.seconds || 0) - (a.updatedAt?.seconds || 0));
  return max ? arr.slice(0, max) : arr;
}

// Remove one series from continue queue
export async function removeSeries(uid, popupId) {
  if (!uid || !popupId) return;
  const ref = userRef(uid);
  const path = `continueSeries.${String(popupId)}`;
  try {
    await updateDoc(ref, { [path]: deleteField() });
  } catch (e) {
    // ensure doc exists then retry
    await setDoc(ref, {}, { merge: true });
    await updateDoc(ref, { [path]: deleteField() });
  }
}
